import apiClient from '../ApiClient';

export const fetchUserReviews = async ({ userId, pageParam = 1}: { userId: number; pageParam: number }): Promise<any> => {
  const res = await apiClient.get(`users/${userId}/reviews`, {
    params: {
      page: pageParam,
    },
  });

  return {
    data: res.data?.data ?? [],
    totalPages: res.data?.pagination?.last_page ?? 0,
    totalItems: res.data?.pagination?.per_page ?? 0,
    currentPage: res.data?.pagination?.current_page ?? 0,
  };
};